import React from 'react';
import EmployeeInformationContainer from "../Containers/EmployeeInformationContainer";
import PanelInformationItem from "../../Atoms/Items/PanelInformationItem";

const ContractPanel = () => {
  return (
    <EmployeeInformationContainer
      title="Contrato"
      icon="document"
    >
      <PanelInformationItem title="Tipo" text="Término fijo" />
      <PanelInformationItem title="Ciudad de trabajo" text="Tepic" />
      <PanelInformationItem title="Fecha de ingreso" text="Fecha de finalización" />
      <PanelInformationItem title="Período de prueba" text="Del 10 abril 2018 hasta el 3 de junio del 2020" twoColumns/>
      <PanelInformationItem title="Frecuencia de pago" text="Mensual" />
      <PanelInformationItem title="Días de descanso" text="Sábado y domingo" />
      <PanelInformationItem title="Tipo de salario" text="No sé qué sea esto" />
      <PanelInformationItem title="Salario" text="3,000,000" />
      <PanelInformationItem title="Cargo" text="Diñador UX" />
      <PanelInformationItem title="Código alterno" text="Tampoco sé qué es" />
      <PanelInformationItem title="Horas trabajadas" text="240" />
    </EmployeeInformationContainer>
  );
};

export default ContractPanel;
